//core module
import React, {useEffect, useState} from "react";

//External module
import {Button, Col, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Form} from "reactstrap";
import cx from 'classnames';

//Internal module
import {
    currencyFormatter,
    handleErrorResponse,
    formatDate, proceeToLink, setSessionValue,
    confirmBoxWithImage,
    parseJSON,
    showToast,
    getSessionValue,
    customLoader,
} from "../../../../Common/Appcommon";
import requestApi from "../../../../services/requestApi.service";
import successtick from "../../../../assets/utils/images/successtick.png"

const BillingInfo = () => {

    const [paymentHistory, setPaymentHistory] = useState({});
    const [addonsData, setAddonsData] = useState({});
    const [licenseInfo, setLicenseInfo] = useState({});
    const [cancelAutoPay, setCancelAutoPay] = useState(false);
    const [cancelSuccess, setCancelSuccess] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isOpenReducer, setIsOpenReducer] = useState(false);
    const [requiredUsers, setRequiredUsers] = useState("");
    const apptype = parseInt(getSessionValue("appType"));

    useEffect(()=>{
        (async ()=>{
            setShowLoader(true)
            await getBillingInfo();
            setShowLoader(false)
        })();
    },[]);

    const getBillingInfo = async () => {
        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'GET_BILLINGINFO'
        }
        let response = await requestApi.processServerRequest(params);

        if(response.issuccess){
            if(response.data){
                const data = response.data;

                setPaymentHistory({...data[0]});
                setLicenseInfo({...data[1]});
                setAddonsData({...data[2]})
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const getTotalAmount = (history, noofuser) => {
        const netAmount = noofuser * history[`rateperuser`];
        return netAmount;
    }

    let subscriptionLabel = "";
    let paymentid = "";
    let method = "";
    let plan = "";
    let noofuser = 0;
    let amount = 0;
    let rateperuser = 0;
    let licenseEndDate = '';
    let CustomerType = "Trial";
    let paymentstatus = paymentHistory['paymentstatus'];

    if(paymentstatus === "Paid" || paymentstatus === "Success" || paymentstatus === "provider_paused") {
        paymentstatus = "Active";
    }else if(paymentstatus === "Cancelled" || paymentstatus === "Payment Failed" || paymentstatus === "Inactive"){
        paymentstatus = "In Active";
    }else if(paymentstatus === "Halted" || paymentstatus === "Pending"){
        paymentstatus = "Pending"
    }

    if(Object.keys(licenseInfo).length > 0){
        if(licenseInfo['license_end_date'] !== "" && licenseInfo['license_end_date'] !== null){
            if (licenseInfo.paymentdetails !=="" && licenseInfo.paymentdetails !== null) {
                let paymentdetails = JSON.parse(licenseInfo.paymentdetails);
                if(paymentdetails["method"] !== undefined && paymentdetails["items"] !== undefined){
                    method = paymentdetails.method;
                    if(method === 'Emandate'){
                        subscriptionLabel = `Token Id`;
                        paymentid = paymentdetails["items"]["tokenid"] ?? "";
                    }else if(method === 'Subscription'){
                        subscriptionLabel = `Subscription Id`;
                        paymentid = paymentdetails['items'][`subscriptionid`] ?? "";
                    }else{
                        subscriptionLabel = `Payment Id`;
                        paymentid = paymentdetails['items'][`paymentid`] ?? "";
                    }
                }
            }    
            licenseEndDate = formatDate(licenseInfo['license_end_date'], 'dd-mmm-yyyy');     
        }
        noofuser = licenseInfo['number_of_user'];
    }

    if(Object.keys(paymentHistory).length > 0){

        CustomerType = paymentHistory['Company_Type'];
        plan = paymentHistory[`frequency`];
        amount = getTotalAmount(paymentHistory, noofuser);
    }

    const handleReducerUser = () => {
        setRequiredUsers("");
        setIsOpenReducer(!isOpenReducer)
    }

    const handOnChange = (e, isNumaric = false) => {
        let name = e.target.name;
        let value = e.target.value;
        if(isNumaric){
            const re = /^[0-9\b]+$/;
            if(value === '' || re.test(value)){
                setRequiredUsers(value);
            }
        }
    }

    const validateReduceUser = () => {
        let isValid = true;
        let errorMsg = "";
        
        if(parseInt(requiredUsers) > parseInt(licenseInfo['number_of_user'])){
            isValid = false;
            errorMsg = "Reduce User: Greater than Total Users";
        }else if(parseInt(requiredUsers) < parseInt(licenseInfo['total_active'])){
            isValid = false;
            errorMsg = "Please check if the active users are fewer than the required users.";
        }else if(parseInt(requiredUsers) === parseInt(licenseInfo['number_of_user'])){
            isValid = false;
            errorMsg = "The same users cannot be reduced.";
        }else if(parseInt(requiredUsers) < parseInt(paymentHistory['Minimum_Users'])){
            isValid = false;
            errorMsg = "Minimum User " + paymentHistory['Minimum_Users'];
        }else if(requiredUsers === 0){
            isValid = false;
            errorMsg = "Zero is not applicable.";
        }

        if(errorMsg !== ""){
            showToast(errorMsg, "top-right", "error");
        }

        return isValid;
    }

    const updateReduceUser = async (e) => {
        e.preventDefault();
        let isValid = validateReduceUser();
        if(!isValid || showLoader){
            return;
        }
        let params = {
            "ENTITY": "razorpay",
            "OPERATION" : 'updateReduceUser',
            "noofuser" : requiredUsers,
            "activeuser" : licenseInfo['total_active'],
            "totalusers" : licenseInfo['number_of_user'],
        }
        setShowLoader(true);
        let res = await requestApi.processServerRequest(params, "web");
        setShowLoader(false);
        if(res.issuccess){
            await getBillingInfo();
            handleReducerUser();
        }else{
            showToast("Some this went Wrong...", "top-right", "error");
        }
    }

    const reducerModalContainer = () => {
        let total_user = licenseInfo['number_of_user'];
        let total_active = licenseInfo['total_active'];
        let remaining_user = licenseInfo['remaining_user'];
        let minimum_users = paymentHistory['Minimum_Users'];
        return (
            <>
                <Modal isOpen = {isOpenReducer} size={"lg"}>
                    <Form onSubmit={updateReduceUser}>
                        <ModalHeader toggle={handleReducerUser}>
                            Reduce Users
                        </ModalHeader>
                        <ModalBody>
                            <Row md={12} className={'mt-2 mb-3'}>
                                <Col md={6}>
                                    <Label className={"group-header-lbl"}>
                                        Current Total Users
                                    </Label>
                                    <Input 
                                        name = {"total_user"}
                                        type = {"text"}
                                        value = {total_user}
                                        disabled = {true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Label className={"group-header-lbl"}>
                                        Active Users
                                    </Label>
                                    <Input 
                                        name = {"total_active"}
                                        type = {"text"}
                                        value = {total_active}
                                        disabled = {true}
                                    />
                                </Col>
                            </Row>
                            <Row md={12} className={'mt-2 mb-3'}>
                                <Col md={6}>
                                    <Label className={"group-header-lbl"}>
                                        Remaining Users
                                    </Label>
                                    <Input 
                                        name = {"remaining_user"}
                                        type = {"text"}
                                        value = {remaining_user}
                                        disabled = {true}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Label className={"group-header-lbl"}>
                                        Minimum Users
                                    </Label>
                                    <Input 
                                        name = {"minimum_users"}
                                        type = {"text"}
                                        value = {minimum_users}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row md={12} className={'mt-2 mb-3'}>
                                <Col md={12}>
                                    <Label className={"group-header-lbl"}>
                                        Required Users
                                    </Label>
                                    <Input 
                                        name = {"required_user"}
                                        type = {"text"}
                                        value = {requiredUsers}
                                        onChange = {e => handOnChange(e, true)}
                                        required
                                    />
                                </Col>
                            </Row>
                            <Row  className={'mt-2 mb-3'} >
                                <Col md={12}>
                                    {/* <input 
                                        name = {"understanded"}
                                        type={"checkbox"}
                                        required
                                    /> */}
                                    <label for="understanded"><p><strong>Note:</strong> Changing users will take effect immediately, and charges will apply at the next renewal.</p></label>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button type={"submit"} className={cx("me-2 btn-icon le-button lePrimaryBtn btn btn-success ", {"cursor-wait" : showLoader})}>
                                Save
                            </Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </>
        )
    }

    const handleClickCancel = async (name) => {
        let confirm = await confirmBoxWithImage("Do you wish to cancel your subscription?", "Click Yes, to cancel your subscription & your account will be accessible till the end of your current subscription period", "", "Yes", "No", "");
        if(confirm){
            setShowLoader(true);
            let params = {
                "ENTITY": "razorpay",
                "OPERATION" : 'cancelSubscription',
                "isUpdateRenewal" : true
            }
            if(name === "Emandate"){
                params["OPERATION"] = "cancelEmandatePayment";
            }
            let response = await requestApi.processServerRequest(params);
            if(response.issuccess){
                if(response.data){
                    await getBillingInfo();
                    setCancelAutoPay(false);
                    setCancelSuccess(true);
                    setSessionValue("licenseValidate" ,'[4,"Payment Cancelled","Your Payment was Cancelled.",true]');    
                }else{
                    showToast("Some thing went wrong...", "top-right", "error");
                }
            }
            setShowLoader(false);
        }

    }

    const getCancelContent = () => {
        return (
            <>
                <div className={`app-main__inner`}>
                    <div className={`billing-subscription-info`}>
                        <Row>
                            <Col>
                                <ul className={`fw-600`}>
                                    <h5>
                                        <strong>{'Cancel Subscription'}</strong>
                                    </h5>
                                </ul>
                                <div className={`listview-container templates-listview kv-main-wrapper h100per`}>
                                    <ul>We're sorry to hear that you're considering cancelling your subscription. </ul>
                                    <ul>Cancellation will be effective at the end of your current billing period on <strong className="error">{licenseEndDate}</strong></ul>
                                    <ul>Before proceeding with the cancellation, we kindly advise you to take the following steps:</ul>
                                    <ul>
                                        <li>Export/Download Your Business Data: We recommend exporting or downloading any necessary information from your Cratio CRM account. This includes contacts, leads, opportunities, and any other data that you may need in the future.</li>
                                        <li>Disconnect 3rd-Party App Integrations: If you have integrated any third-party applications with your Cratio CRM account, it is important to disconnect them before canceling your subscription. This will help prevent any disruptions or data loss that may occur due to the disconnection.</li>
                                    </ul>
                                    <ul>Furthermore, please note the following important information:</ul>
                                    <ul>
                                        <li>If you decide to restart your subscription within three months, your account schema and other details will be preserved, allowing for a seamless continuation of your CRM experience.</li>
                                        <li>After three months, your data might be automatically deleted from our systems. To avoid any loss, we recommend taking the necessary steps to preserve your data before that time.</li>
                                    </ul>
                                    <ul>We genuinely hope that your experience using Cratio CRM has been positive, and we appreciate the opportunity to serve you as our customer.</ul>
                                    <ul>If there is anything we can do to assist you further, or if you have any concerns or questions, please do not hesitate to reach out to our dedicated customer support team <strong className="cancel-sub-mail-ph"> Email: <a href="mailto:support@cratio.com">support@cratio.com</a> Phone: <a href="tel:+91-7418191100">+91-7418191100</a></strong>. We are here to help.</ul>
                                    <ul>Thank you for considering Cratio CRM for your business needs, and we extend our best wishes to you in all your future endeavors.</ul>
                                    <ul className="cancel-subscription-btn-container">
                                        <Button className="mt-3 m-1 me-2 btn-icon sub-cancel-btn" onClick={e => handleClickCancel(paymentHistory[`paymenttype`])}>Finish Cancellation</Button>
                                        <Button className="mt-3 m-1 me-2 btn-icon le-button lePrimaryBtn btn btn-success" onClick={e => setCancelAutoPay(false)}>Go Back</Button>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </>
        )
    }

    if(cancelAutoPay && !cancelSuccess){
        return (
            customLoader({
                showLoader: showLoader,
                customClass: "custom-class",
                mainContent: getCancelContent(),
            })
        )
        
    }

    if(cancelSuccess && !cancelAutoPay){

        return (
            <>
                 <div className="Payment-confirm">
                    <div className="Payment-confirm">
                        <img src={successtick} className="Payment-confirm-image"></img>
                    </div>

                    <div className="Payment-confirm-list">
                        <span className="subscription-title Payment-confirm-text ">
                            Subscription canceled successfully
                        </span>
                    </div>

                    <div className="Payment-confirm">
                        <Button onClick={() => setCancelSuccess(false)} className="m-1 me-2 btn-icon le-button lePrimaryBtn btn btn-success">
                            Show Details
                        </Button>
                    </div>
                </div>
            </>
        )
    }

    const getContent = () => {

        let paymentdetails = licenseInfo['paymentdetails'];
        let paymentstatus  = paymentHistory[`paymentstatus`];
        if(paymentstatus === "provider_paused"){
            paymentstatus = "Active";
        }
        let paymenttype  = paymentHistory[`paymenttype`];
        let campanytype  = paymentHistory[`Company_Type`];
        let last_payment_status  = paymentHistory[`last_payment_status`];
        const hideBtn = campanytype !== "Customer" && (!paymentdetails);
        const buttonsConfig = [
            {
                name: "update_billing",
                label: "Update Billing Info",
                onClick: () => proceeToLink(`/#/settings/account/organization`, true),
                show: !(paymentstatus === 'Inactive' || paymentstatus === 'Cancelled' || paymentstatus === 'Payment Failed') && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "subscribe_plan",
                label: "Subscribe Plan",
                onClick: () => proceeToLink(`/#/subscription`, false),
                show: !hideBtn && paymenttype === "Online",
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "upgrade_plan",
                label: "Upgrade Plan",
                onClick: () => proceeToLink(`/#/subscription/upgrade`, false),
                show: !(paymentstatus === 'Cancelled' || paymentstatus === 'Inactive' || paymentstatus === 'Payment Failed') && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "resubscribe",
                label: "Resubscribe to Cratio CRM",
                onClick: () => proceeToLink(`/#/subscription`, false),
                show: !(paymentstatus !== 'Cancelled' && paymentstatus !== 'Inactive' && paymentstatus !== 'Payment Failed') && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "additional_user",
                label: "Add Additional Users",
                onClick: () => proceeToLink(`/#/subscription/addonusers`, false),
                show: !(last_payment_status === "created" || (paymenttype !== "Online" && (apptype === 1 || paymentstatus === 'Inactive' || paymentstatus === 'Cancelled' || paymentstatus === 'Payment Failed'))) && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "reduce_user_link",
                label: "Reduce Users",
                onClick: () => proceeToLink('/#/subscription/reduceusers', false),
                show: paymentHistory[`paymenttype`] === "Subscription" && !(apptype === 1 || paymenttype === "Online" || paymentstatus === 'Cancelled' || paymentstatus === 'Payment Failed') && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "reduce_user_btn",
                label: "Reduce Users",
                onClick: () => handleReducerUser(),
                show: paymentHistory[`paymenttype`] !== "Subscription" && !(apptype === 1 || paymentstatus === 'Inactive' || paymentstatus === 'Cancelled' || paymenttype !== "Emandate") && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "addons",
                label: "Customized Addons",
                onClick: () => proceeToLink(`/#/subscription/addons`, false),
                show: !(!addonsData['isAddonsEnabled'] || paymentstatus === 'Cancelled' || paymentstatus === 'Payment Failed') && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "update_subscription",
                label: "Update Subscription",
                onClick: () => proceeToLink(`/#/subscription`, false),
                show: !(paymentstatus !== 'Payment Failed') && !hideBtn,
                className: "le-button lePrimaryBtn btn btn-success"
            },
            {
                name: "cancel_emandate",
                label: "Cancel Subscription",
                onClick: () => setCancelAutoPay(true),
                show: paymentHistory[`paymenttype`] === "Emandate" && !(paymentstatus === 'Inactive' || paymentstatus === "provider_cancelled") && !hideBtn,
                className: "sub-cancel-btn"
            },
            {
                name: "cancel_subscription",
                label: "Cancel Subscription",
                onClick: () => setCancelAutoPay(true),
                show: paymentHistory[`paymenttype`] !== "Emandate" && !(paymenttype === "Online" || paymentstatus === 'Cancelled' || paymentstatus === 'Payment Failed' || paymentstatus === "provider_paused") && !hideBtn,
                className: "sub-cancel-btn"
            }
        ];

        const showNextPayment = !(paymenttype === "Emandate" && paymentstatus !== "Active");
        const showPaymentFrequency = !(paymenttype === "Emandate" && paymentstatus !== "Active");
        const showStatus = !((paymenttype === "Online") || (paymenttype === "Emandate" && paymentstatus === "Active"));

        return (
            <>
                <div className={`billing-container`}>
                    {
                        CustomerType === "Customer" ?

                        <Row className={`billing-content-wrapper`}>
                            <Col md={'12'}>
                                <div className={`billing-subscription-info`}>
                                    <span className={`fw-600`}>Subscription Details</span>
                                    {
                                        paymentid !== null && 
                                        <span className={`billing-subscription-identity fw-200`}>{subscriptionLabel} : {paymentid}</span>
                                    }
                                </div>
                                <div className={`billing-subscription-table`}>
                                    <table className={'le-table no-border-table table table-bordered table-hover billing-subscription-table'}>
                                        <thead> 
                                            <tr>
                                                <th className={'text-left'}>ITEM</th>
                                                <th className={'text-center'}>NO.OF UNITS</th>
                                                <th className={'text-center'}>CHARGES</th>
                                                <th className={'text-center'}>TOTAL /MONTH</th>
                                                {
                                                    showNextPayment && 
                                                    <th className={'text-center'}>NEXT PAYMENT</th>
                                                }
                                                {
                                                    showPaymentFrequency && 
                                                    <th className={'text-center'}>PAYMENT FREQUENCY</th>
                                                }
                                                {
                                                    showStatus && 
                                                    <th className={"text-center"}>STATUS</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className={'text-left fw-100'}>{`${plan} Plan`}</td>
                                                <td className={'text-center fw-100'}>{`${noofuser} users`}</td>
                                                <td className={'text-center fw-100'}>{currencyFormatter('en-IN', 'INR', paymentHistory['rateperuser'], 2)} /user&nbsp;/month</td>
                                                <td className={'text-center fw-100'}>{currencyFormatter('en-IN', 'INR', amount, 2)}  +18%&nbsp;GST</td>
                                                {
                                                    showNextPayment && 
                                                    <td className={'text-center fw-100'}>{licenseEndDate}</td>
                                                }
                                                {
                                                    showPaymentFrequency && 
                                                    <td className={'text-center fw-100 uppercase'}>{plan}</td>
                                                }
                                                {
                                                    showStatus && 
                                                    <td className={"text-center fw-100"}>
                                                        <p 
                                                            className={cx(
                                                                {
                                                                    "payment-success" :  paymentstatus === "Active",
                                                                    "payment-cancel" : paymentstatus === "Inactive",
                                                                    "payment-pending" : paymentstatus === "Pending",
                                                                    "payment-cancel" : paymentHistory[`paymenttype`] === "Emandate",
                                                                }
                                                            )}
                                                        >{paymentstatus === "Active" ? "Active" : "Cancelled"}
                                                        </p>
                                                    </td>
                                                }
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={`text-center`}>
                                    {buttonsConfig.map((btn, index) => (
                                        btn.show && (
                                            <Button
                                                key={index}
                                                onClick={btn.onClick}
                                                className={cx("mt-3 m-1 me-2 btn-icon", btn.className)}
                                            >
                                                {btn.label}
                                            </Button>
                                        )
                                    ))}
                                </div>
                            </Col>
                            <Row>
                                {
                                    paymentHistory[`paymentstatus`] === 'Cancelled' && 
                                    <Col>
                                        <h3>
                                            Note : 
                                        </h3> 
                                        <div>
                                            Your subscription has been successfully canceled, and the cancellation will take effect at the end of your current billing period, which is on {licenseEndDate} . Resubscribe to Cratio CRM
                                        </div>
                                    </Col>
                                }
                                {
                                    paymentHistory[`paymentstatus`] === 'Payment Failed' &&
                                    <Col>
                                        <div>
                                            Action Required! Your subscription payment has failed. Please update your payment method for the subscription and reactivate your account.
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </Row>  :
                        <div className={`billing-content-wrapper`}>
                            <h5>Paid Trial/ Free Trial</h5>
                            <div>
                                <strong>
                                    Current Plan:
                                </strong>
                                <p>
                                    You are in the <strong>Trial Plan</strong>, valid until <strong>{licenseEndDate} </strong>
                                </p>
                                <Button onClick={()=>proceeToLink(`/#/subscription`, false)} className={cx("mt-3 m-1 me-2 btn-icon le-button lePrimaryBtn btn btn-success")}>
                                    {`Subscribe Plan`}
                                </Button>                        
                            </div>
                        </div>
                    }
                    <div>
                        {
                            customLoader({
                                showLoader: showLoader,
                                customClass: "custom-class",
                                mainContent: reducerModalContainer(),
                            })
                        }
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            {customLoader({
                showLoader: showLoader,
                customClass: "custom-class",
                mainContent: getContent(),
            })}
        </>
    );
}

export default BillingInfo;